import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Avatar, Spinner } from "@/components/common";

export function ImageUpload({ value, onChange, name, testid = "profile-picture-upload" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/profile-picture", fd);
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex items-center gap-4">
      <Avatar src={value} name={name || "?"} size="h-16 w-16" />
      <button type="button" onClick={() => ref.current.click()} data-testid={testid} disabled={busy}
        className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-[#0B1A33] transition-colors hover:border-[#1F6FFF] hover:text-[#1F6FFF]">
        {busy ? <Spinner /> : <Upload className="h-4 w-4" />} {value ? "Change photo" : "Upload photo"}
      </button>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
